module.exports = "<span class=\"box-message\">\n  URL copied...!!!\n</span>\n"